import { render, staticRenderFns } from "./addBankAccountForm.vue?vue&type=template&id=fbb815ee"
import script from "./addBankAccountForm.vue?vue&type=script&lang=js"
export * from "./addBankAccountForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports